<script lang="ts" setup>
import VeeTextarea from '@/components/forms/Textarea/VeeTextarea.vue';
import VeeAttachments from '@/components/forms/Attachments/VeeAttachments.vue';
import { FormMode } from '@/components/forms/types';

interface InstructionsProps {
  textAreaContent: string | null | undefined;
  areaIndex: number;
  mode: FormMode;
}
defineProps<InstructionsProps>();
</script>

<template>
  <v-card class="content-block">
    <v-card-item>
      <v-card-title>
        <h5 class="mb-0">{{ $t('Instruction_one') }}</h5>
      </v-card-title>
    </v-card-item>

    <v-card-text>
      <VeeTextarea
        :name="`taskItemAreas[${areaIndex}].instruction.textAreaContent`"
        :placeholder="
          mode === 'add' || mode === 'edit'
            ? $t('InstructionsPlaceholder')
            : $t('NoInstructionsAvailable')
        "
        rows="3"
        :maxRows="10"
        noResize
        autoGrow
        :mode="mode"
        :class="{ 'text-body-1': mode === 'details' && !textAreaContent }"
      />
      <VeeAttachments
        class="mt-1 w-33"
        :name="`taskItemAreas[${areaIndex}].instruction.attachments`"
        :mode="mode"
        data-testid="Instructions_Attachments"
      />
    </v-card-text>
  </v-card>
</template>
